
<style scoped>
.query-form {
    margin-top: 40px;
}
</style>

<template>
     <div>
        <h1>发布动态</h1>
        <div class="query-form">
            <el-form :model="ruleAddMoment" status-icon :rules="addMomentRule" ref="ruleAddMoment" class="demo-ruleForm">
                <el-form-item label="模板类型" label-width="80px">
                    <el-select v-model="ruleAddMoment.templateType" style="width:300px;">
                        <el-option v-for="item in templateType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="默认点赞" label-width="80px">
                    <el-input type="number" v-model="ruleAddMoment.defaultLike" auto-complete="off" placeholder="请输入默认点赞数" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="文本内容" label-width="80px" prop="textValue">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="ruleAddMoment.textValue"
                        maxlength="200"
                        style="width:600px;"
                        show-word-limit
                    >
                    </el-input>   
                </el-form-item>
                <el-form-item v-if="ruleAddMoment.templateType==2" label="上传图片" label-width="80px" prop="photoIdList">
                    <el-upload
                        ref="upload"
                        :action="action"
                        :headers = "headers"
                        accept="image/png, image/jpeg, image/jpg"
                        :limit=9
                        multiple
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-success="handleSuccess"
                        :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过10M</div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item v-if="ruleAddMoment.templateType==3" label="上传视频" label-width="80px" prop="photoIdList">
                    <el-upload
                        ref="upload"
                        class="upload-demo"
                        :action="actionMedia"
                        :headers = "headers"
                        accept="video/mp4"
                        :limit=1
                        :show-file-list="false"
                        :on-remove="handleMediaRemove"
                        :on-success="handleMediaSuccess"
                        element-loading-text="上传中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.1)"
                        >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div>
                            <video v-if="videoPath !=''"  
                            :src="videoPath" 
                            class="avatar video-avatar"
                            style="width: 600px"
                            controls="controls">您的浏览器不支持视频播放</video>  
                        </div>
                        <el-progress v-if="videoFlag == true"
                            type="circle"
                            :percentage="videoUploadPercent"
                            style="margin-top:30px;"></el-progress>
                        <!-- <el-button slot="trigger" size="small" type="primary">选择视频</el-button> -->
                        <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过10M</div>
                    </el-upload>
                    
                </el-form-item>
                <el-form-item v-if="ruleAddMoment.templateType==3" label="上传视频封面" label-width="80px" prop="cover">
                    <el-upload
                        ref="upload"
                        :action="actionCover"
                        :headers = "headers"
                        accept="image/png, image/jpeg, image/jpg"
                        :limit=1
                        list-type="picture-card"
                        :on-preview="handleCoverPreview"
                        :on-remove="handleCoverRemove"
                        :on-success="handleCoverSuccess"
                        :before-upload="beforeCoverUpload">
                        <i class="el-icon-plus"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过10M</div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogCoverVisible">
                        <img width="100%" :src="dialogCoverImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item>
                    <el-button class="button-width" type="primary" @click="addMoment('ruleAddMoment')">发布动态</el-button>
                </el-form-item>
            </el-form>
        </div>
     </div>
</template>

<script>
import app from '@/App.vue';
import {uploadPhoto, addMoment} from '@/request/api';

export default {
    data() {
        var checkValue = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('文本内容不能为空'));
            }
            callback();
        };
        return {
            activeName: 'addMoment',
            headers: {authorization: app.globalData.userInfo.token},  
            action: "/console/upload/uploadPhoto",
            actionMedia: "/console/upload/uploadMedia",
            actionCover: "/console/upload/uploadCover",
            templateType: app.templateType,
            dialogImageUrl: '',
            dialogVisible: false,
            dialogCoverImageUrl: '',
            dialogCoverVisible: false,
            fileList: [],
            videoPath: '',
            videoFlag: false,
            ruleAddMoment: {
                mediaId: 0,
                photoIdList: [],
                textValue: '',
                templateType: 1,
                coverUrl: '',
                defaultLike: 0
            },
            addMomentRule: {
                textValue: [
                    { validator: checkValue, trigger: 'blur'}
                ]
            },
            loading: false
        };
    },
    methods: {
        beforeCoverUpload(file) {
            const is1M = file.size / 1024 / 1024 < 10; // 限制小于1M

            if (!is1M) {
                this.$message.error('请上传大小不可超过10MB的图片')
            }
            return is1M
        },
        handleCoverRemove(file, fileList) {
            //获取response中的id
            const data = file.response.data
            //从pics数组中，找到图片对应的索引值
            const i = this.ruleAddMoment.photoIdList.findIndex(x => x === data)
            //移除元素
            this.ruleAddMoment.photoIdList.splice(i, 1)
        },
        handleCoverPreview(file) {
            this.dialogCoverImageUrl = file.url;
            this.dialogCoverVisible = true;
        },
        handleCoverSuccess(response, file, fileList) {
            var status = response.status;
            var data = response.data
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.ruleAddMoment.coverUrl = data
            }
        },
        beforeUpload(file) {
            const is1M = file.size / 1024 / 1024 < 10; // 限制小于1M

            if (!is1M) {
                this.$message.error('请上传大小不可超过10MB的图片')
            }
            return is1M
        },
        handleRemove(file, fileList) {
            //获取response中的id
            const data = file.response.data
            //从pics数组中，找到图片对应的索引值
            const i = this.ruleAddMoment.photoIdList.findIndex(x => x === data)
            //移除元素
            this.ruleAddMoment.photoIdList.splice(i, 1)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleSuccess(response, file, fileList) {
            var status = response.status;
            var data = response.data
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.ruleAddMoment.photoIdList.push(data)
            }
        },
        handleMediaRemove(file, fileList) {
            console.log(file, fileList);
            this.ruleAddMoment.mediaId = 0
        },
        handleMediaSuccess(response, file, fileList) {
            var status = response.status;
            var data = response.data
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.ruleAddMoment.mediaId = data.mediaId
                this.videoPath = data.mediaUrl
            }
            console.log(this.ruleAddMoment.mediaId)
        },
        uploadVideoProcess (event, file, fileList) {
            this.videoFlag = true;
            this.videoUploadPercent = file.percentage.toFixed(0) * 1;
        },
        addMoment(formName) {
            if (this.ruleAddMoment.templateType.length == 0) {
                this.$message.error('请选择模板类型');
                return;
            }
            if (this.ruleAddMoment.templateType == 2
            && this.ruleAddMoment.photoIdList.length == 0) {
                this.$message.error('请上传至少一张图片');
                return;
            }
            if (this.ruleAddMoment.templateType == 3
            && this.ruleAddMoment.mediaId == 0) {
                this.$message.error('请上传视频');
                return;
            }
            if (this.ruleAddMoment.templateType == 3
            && this.ruleAddMoment.coverUrl == '') {
                this.$message.error('请上传视频封面');
                return;
            }
            if (this.ruleAddMoment.defaultLike < 0) {
                this.$message.error('请输入0或以上点赞数');
                return;
            }
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    addMoment({
                        textValue: this.ruleAddMoment.textValue,
                        photoIdList: this.ruleAddMoment.photoIdList,
                        mediaId: this.ruleAddMoment.mediaId,
                        templateType: this.ruleAddMoment.templateType,
                        defaultLike: this.ruleAddMoment.defaultLike,
                        coverUrl: this.ruleAddMoment.coverUrl,
                    }).then(res => {
                        var status = res.status;
                        var msg = res.msg;
                        if (status === '2') {
                            this.$message.error(msg);
                        } else {
                            this.$message.success("发布成功");
                            this.$refs['ruleAddMoment'].resetFields();
                            this.$refs.upload.clearFiles()
                        }
                    })


                } else {
                    console.log('error');
                    return false;
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/appIndex/addMoment.vue